import * as uiReducers from './uiReducers'
import { combineReducers } from 'redux'
import { orm } from '../../models/models'
import users from './users'
import { createReducer } from 'redux-orm'

let rootReducer = combineReducers({
  orm: createReducer(orm),
  ui: combineReducers(uiReducers),
  users
})

export default rootReducer
